import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AS } from "../lib/siteStatus";

export default function OperatorSignIn() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) nav("/admin", { replace: true });
    else setError(res.error);
  };

  const input = "w-full rounded-md border px-3 py-2.5 outline-none focus:ring-2";
  const inputStyle = { background: AS.surface, color: AS.text, borderColor: AS.border };

  return (
    <main className="min-h-screen flex items-center" style={{ background: AS.bg, color: AS.text }}>
      <form
        onSubmit={submit}
        data-testid="operator-signin-form"
        className="mx-auto w-full max-w-md rounded-xl border p-6 sm:p-8"
        style={{ background: AS.panel, borderColor: AS.panelBorder, color: AS.panelText }}
      >
        <h1 className="text-2xl font-semibold">AnswerStrike Academy</h1>
        <p className="mt-2 text-sm" style={{ color: AS.panelMuted }}>Administrator sign-in</p>
        <input
          data-testid="operator-email-input" type="email" required autoComplete="username"
          placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
          className={`${input} mt-6`} style={inputStyle}
        />
        <input
          data-testid="operator-password-input" type="password" required autoComplete="current-password"
          placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)}
          className={`${input} mt-3`} style={inputStyle}
        />
        {error && (
          <p data-testid="operator-signin-error" className="mt-3 text-sm" style={{ color: AS.button }}>{error}</p>
        )}
        <button
          data-testid="operator-signin-submit" type="submit" disabled={busy}
          className="mt-6 inline-flex rounded-md px-5 py-3 font-semibold transition-opacity hover:opacity-90 disabled:opacity-60"
          style={{ background: AS.button, color: AS.text }}
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
